import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../constent";

// Async Thunks

// 1. Login User
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/auth/signin`, {
        email,
        password,
      });

      if (response.data.user && response.data.token) {
        return {
          user: response.data.user,
          accessToken: response.data.token,
          userId: response.data.userId,
        };
      }

      if (response.data.returnToSignup) {
        return {
          returnToSignup: response.data.returnToSignup,
        };
      }

      return thunkAPI.rejectWithValue({
        message: response.data.status || "Login failed",
      });
    } catch (error) {
      if (
        error.response?.status === 404 &&
        error.response?.data?.returnToSignup === true
      ) {
        return {
          returnToSignup: true,
        };
      }

      const message = error.response?.data?.message || "Login failed";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 2. OTP
export const loginWithOTP = createAsyncThunk(
  "auth/loginWithOTP",
  async ({ otp }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${API_URL}/auth/signup/configurationOTP`,
        { otp }
      );
      // console.log(response);
      return {
        user: response?.data?.data?.user,
        accessToken: response?.data?.data?.token,
      };
    } catch (error) {
      const message = error.response?.data?.message || "OTP failed";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 3. RESENS OTP
export const ResendOTP = createAsyncThunk(
  "auth/ResendOTP",
  async ({ email }, thunkAPI) => {
    try {
      // console.log(email)
      const response = await axios.post(`${API_URL}/auth/resendOTP`, { email });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to reset password";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 4. Register User
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (userData, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/auth/signup`, userData);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Registration failed";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 5. Forgot Password Thunk
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async ({ email }, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/auth/forgetPassword`, {
        email,
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to send reset email";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 6. Reset Password
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ token, password }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${API_URL}/auth/resetPassword?token=${token}`,
        { newPassword: password }
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to reset password";
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// 7. lOGOUT
export const logoutUser = createAsyncThunk(
  "jwtCheck/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      // Delete the token from LocalStorage
      localStorage.removeItem("accessToken");

      return { success: true, message: "Logged out successfully" };
    } catch (error) {
      return rejectWithValue("An error occurred while logging out");
    }
  }
);

// export const loginGoogle = createAsyncThunk(
//   "auth/loginGoogle",
//   async (_, thunkAPI) => {
//     try {
//       const response = await axios.get(`${API_URL}/google`);
//       return response.data;
//     } catch (error) {
//       const message =
//         error.response?.data?.message || "Failed to reset password";
//       return thunkAPI.rejectWithValue({ message });
//     }
//   }
// );

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    accessToken: null,
    userId: null,
    loading: false,
    error: null,
    message: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.error = null;
      state.message = null;
    },

    resetForgotPasswordState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login User
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;
        // console.log(state.accessToken);
        localStorage.setItem("accessToken", action.payload.accessToken);
        state.message = "Login successful!";
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Login failed";
      })

      // Register User
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Registration successful!";
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Registration failed";
      })

      // Forgot Password
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      // Forgot Password Fulfilled
      .addCase(forgotPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      // Forgot Password Rejected
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "An error occurred.";
      })
      // Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Password_reset_successfully";
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to reset password";
      })

      .addCase(loginWithOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginWithOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;

        localStorage.setItem("accessToken", action.payload.accessToken);
      })
      .addCase(loginWithOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "OTP failed";
      });
  },
});

export const { logout, resetForgotPasswordState } = authSlice.actions;
export default authSlice.reducer;
